import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchJobLeaveById } from "services/job-leave.service";
import { JobLeave } from "types/JobLeave";
import { AppDispatch } from "configureStore";

interface JobLeaveViewState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  jobLeave: JobLeave | null;
}

const initialState: JobLeaveViewState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  jobLeave: null,
};

const JobLeaveViewSlice = createSlice({
  name: "jobLeaveView",
  initialState,
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<{ error: string }>) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state, action: PayloadAction<JobLeave>) {
      state.jobLeave = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
  },
});

const { actions, reducer } = JobLeaveViewSlice;

export const { setDestroy, setLoading, setError, setData } = actions;
export default reducer;

export const fetchJobLeaveDetails =
  (companyId: string, jobLeaveId: string) =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const data = await fetchJobLeaveById(companyId, jobLeaveId);
      dispatch(setData(data));
    } catch (e) {
      dispatch(setError({ error: "not_fetch" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
